<template>
  <v-card flat style="min-width: 410px;">
    <!-- Header / Toolbar -->
    <v-toolbar dense dark color="primary">
      <v-toolbar-title>交易紀錄</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- 內容區 -->
    <v-card-text>
      <v-subheader class="text-h6 font-weight-bold mt-2">交易資訊</v-subheader>
      <v-container fluid>
        <v-row dense>
          <!-- 4 -->
          <v-col cols="12" md="6" lg="3"><strong>交易日期：</strong>{{ invDetailsView.payDate }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>繳費租期：</strong>{{ invDetailsView.startDateToEndDate }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>場地名稱：</strong>{{ invDetailsView.siteName }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>租戶名稱：</strong>{{ invDetailsView.rentInfoName }}</v-col>
          <!-- 4 -->
          <v-col cols="12" md="6" lg="3"><strong>列印狀態：</strong>{{ invPrintState(invDetailsView.printState) }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>載具類型：</strong>{{ carrierTypeLabel(invDetailsView.carrierType) }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>載具編碼：</strong>{{ invDetailsView.vehicleCode }}</v-col>
        </v-row>
      </v-container>
      <!-- ─────── 發票資訊 ─────── -->
      <v-subheader class="text-h6 font-weight-bold mt-2">發票資訊</v-subheader>
      <v-container fluid>
        <v-row dense>
          <v-col cols="12" md="6" lg="3"><strong>發票號碼：</strong>{{ invDetailsView.invoiceNum }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>發票期號：</strong>{{ invDetailsView.mon }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>發票隨機碼：</strong>{{ invDetailsView.guiNo }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>發票類型：</strong>{{ invTypeLabel(invDetailsView.invType) }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>發票金額：</strong>{{ toThousand(invDetailsView.price) }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>未稅金額：</strong>{{ toThousand(invDetailsView.notTaxPrice) }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>稅額：</strong>{{ toThousand(invDetailsView.taxPrice) }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>課稅別：</strong>{{ taxLabel(invDetailsView.taxType) }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>賣方統編：</strong>{{ invDetailsView.sellerNum }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>買方統編：</strong>{{ invDetailsView.buyerNum }}</v-col>
          <v-col cols="12" md="6" lg="3"><strong>發票狀態：</strong>{{ invState(invDetailsView.state) }}</v-col>
        </v-row>
      </v-container>

      <!-- ─────── 商品明細 ─────── -->
      <v-subheader class="text-h6 font-weight-bold my-4">交易明細</v-subheader>
      <v-data-table
        :headers="invDetailsView.itemHeaders"
        :items="invDetailsView.items"
        class="elevation-1 mb-6"
        dense
        hide-default-footer
      />
      <v-row dense justify="center">
        <v-btn dark color="primary" v-if="downloadInvoice && invDetailsView.state === 1" @click="downloadInvoice">
          下載電子發票證明聯
        </v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TradeDetailDialog',
  props: {
    invDetailsView: {
      type: Object,
      required: true
    },
    downloadInvoice: {
      type: Function
    }
  },
  methods: {
    toThousand(n) {
      return Number(n).toLocaleString("zh-TW");
    },
    taxLabel(type) {
      return { 1: "應稅", 2: "零稅率", 3: "免稅" }[type] || "-";
    },
    invTypeLabel(type) {
      return {
        1: '二收銀發票',
        2: '電子式發票',
        3: '三聯式手開發票',
        4: '二聯式手開發票',
        5: '自印二收銀發票'
      }[type] || '-';
    },
    carrierTypeLabel(type) {
      return {
        1: '手機條碼',
        2: '自然人憑證',
        3: '悠遊卡',
        4: '一卡通',
        5: '信用卡',
        6: 'icash',
        7: 'FETC會員',
        8: 'ERC會員載具',
        9: '致富寶會員'
      }[type] || '';
    },
    invPrintState(state){
      return{
        0: '未列印',
        1: '已列印',
        2: '雲端下載'
      }[state] || "-"
    },
     invState(state){
      return{
        0: '未使用',
        1: '開立',
        2: '作廢',
        3: '折讓',
      }[state] || "-"
    },
  }
};
</script>

<style scoped>
.v-subheader {
  padding-left: 0;
}
</style>
